<div
    class="share-container d-flex flex-column justify-content-center align-items-center"
    (click)="closeShareScreen()"
>
    <!-- Clicking anywhere inside the share-container will trigger the closeShareScreen() function.
     The visual close button below is just for indicating a close action to the user. -->
    <span class="close-btn d-flex justify-content-end">
        <img
            src="/img/icons/xmark-circle.svg"
            alt="CloseButton"
            height="20"
            width="20"
        />
    </span>
    <div *ngIf="selectedDbc?.user_image_url" class="pt-3">
        <img
            [src]="selectedDbc.user_image_url"
            alt="Profile"
            class="profile-picture"
        />
    </div>
    <div class="owner-name pt-2">
        <span>{{ selectedDbc?.full_name | truncate: 25 }}</span>
    </div>
    <div class="qr-preview-container">
        <div [innerHtml]="qrCode | getSanitizedHtml" class="qr-container"></div>
    </div>

    <div
        (click)="shareByOsOptions(); $event.stopPropagation()"
        class="share-button d-flex justify-content-center align-items-center cursor-pointer"
    >
        <span class="d-flex justify-content-center align-items-center">
            <img
                src="/icons/dbc/share-dark.svg"
                alt="Share"
                class="share-icon"
            />
        </span>
        <span class="py-2 pointer-events-none">Share Link</span>
    </div>

    <div
        (click)="openWalletPassLink(googleWalletPassLink)"
        (keyup)="openWalletPassLink(googleWalletPassLink)"
        (keydown)="openWalletPassLink(googleWalletPassLink)"
        class="share-button d-flex justify-content-center align-items-center"
        *ngIf="!isIos && googleWalletPassLink"
    >
        <img src="/icons/dbc/google_logo.svg" alt="Google Wallet" />
        <div class="padding-left-4">Add to Google Wallet</div>
    </div>

    <div
        (click)="openWalletPassLink(appleWalletPassLink)"
        (keyup)="openWalletPassLink(appleWalletPassLink)"
        (keydown)="openWalletPassLink(appleWalletPassLink)"
        class="share-button d-flex justify-content-center align-items-center"
        *ngIf="isIos && appleWalletPassLink"
    >
        <img
            src="/icons/dbc/apple_logo.svg"
            alt="Apple Wallet"
            class="padding-bottom-1px"
        />
        <div class="padding-left-4">Add to Apple Wallet</div>
    </div>
</div>
